import React from 'react';
import IndexPage from './index';

const ContactPage = () => {
  return <IndexPage article={'contact'} />;
};

export default ContactPage;
